import React from 'react';
import './BulkUpload.css';
import Sidebar from '../../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../../assests/leftArrow.svg"
import { useNavigate } from "react-router-dom";
import validationsuccess from "../../../../assests/validationsuccess.svg"
import validationfailed from "../../../../assests/validationfailed.svg"
import csvicon from "../../../../assests/csvicon.png"

const BulkUpload = ({
  // State
  currentStep,
  uploadedFile,
  validationStatus,
  mappingData,
  validationResults,
  isValidating,
  isMapping,
  showAlreadyMapped,
  showValidationDialog,
  showMappingSuccessDialog,
  showMissingRecordsDialog,
  uploadProgress,

  // Actions
  onFileUpload,
  onDrop,
  onDragOver,
  onValidate,
  onRemoveEntry,
  onRemoveAllAlreadyMapped,
  onMap,
  onReset,
  onTryAgain,
  setCurrentStep,
  onValidationDialogOk,
  onMappingSuccessDialogOk,
  onMissingRecordsDialogOk,

  // Utilities
  getUploadProgressPercentage,
  getUploadProgressText
}) => {
  const navigate = useNavigate();

  // Calculate file entities count
  const getFileEntitiesCount = () => {
    if (validationResults) {
      return validationResults.totalEntries;
    }
    return mappingData.length;
  };

  // Check if there are no unmapped entries available
  const hasNoUnmappedEntries = !showAlreadyMapped && mappingData.length === 0;

  // Check if validation failed
  const isValidationFailed = validationStatus === 'error';

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div className="bulk-upload-container">
        <div className="uid-header-section">
          <button
            className="uid-back-button"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <img src={leftArrow} alt="Back" />
          </button>
          <h1>Bulk Upload</h1>
        </div>

        {/* Stepper - Numbered style from screenshots */}
        <div className="stepper">
          <div className={`step ${currentStep >= 1 ? 'active' : ''}`}>
            <div className="step-number">1</div>
            <div className="step-label">Upload File</div>
          </div>
          <div className="step-connector"></div>
          <div className={`step ${currentStep >= 2 ? 'active' : ''}`}>
            <div className="step-number">2</div>
            <div className="step-label">Validation</div>
          </div>
          <div className="step-connector"></div>
          <div className={`step ${currentStep >= 3 ? 'active' : ''}`}>
            <div className="step-number">3</div>
            <div className="step-label">Mapping</div>
          </div>
        </div>

        <div className="bulk-upload-content">
          {/* Step 1: Upload File */}
          {currentStep === 1 && (
            <div className="step-content">
              <div className="upload-section">
                <h2>Upload File</h2>
                <div
                  className="file-upload-area"
                  onDrop={onDrop}
                  onDragOver={onDragOver}
                >
                  <div className="upload-placeholder">
                    <p>Choose file or drag here</p>
                  </div>
                  <input
                    type="file"
                    id="file-upload"
                    onChange={onFileUpload}
                    accept=".csv"
                    style={{ display: 'none' }}
                  />
                  <label htmlFor="file-upload" className="file-upload-button">
                    Select File
                  </label>
                </div>
              </div>
            </div>
          )}

          {/* Step 2: Validation */}
          {currentStep === 2 && (
            <div className="step-content">
              <div className="validation-section">
                <h2>Validation</h2>

                {uploadedFile && (
                  <div className="upload-status">
                    <div className="status-message success">
                      File Uploaded Successfully
                    </div>

                    <div className="file-item">
                      <div className="file-checkbox">
                        <img className='csviconclass' src={csvicon} alt="" />
                      </div>
                      <div className="file-details">
                        <span className="file-name">{uploadedFile.name}</span>
                        <div className="progress-container">
                          <div className="progress-bar">
                            <div
                              className="progress-fill"
                              style={{ width: `${getUploadProgressPercentage()}%` }}
                            ></div>
                          </div>
                          <span className="progress-text">{getUploadProgressText()}</span>
                        </div>
                      </div>
                    </div>

                    {validationStatus === 'ready' && (
                      <div className="validate-action">
                        <button
                          className="btn-validate"
                          onClick={onValidate}
                          disabled={isValidating}
                        >
                          {isValidating ? 'Validating...' : 'Validate'}
                        </button>
                      </div>
                    )}

                    {validationStatus === 'progress' && (
                      <div className="validation-progress">
                        <div className="progress-message">
                          Validation in Progress
                        </div>
                      </div>
                    )}

                    {validationStatus === 'success' && (
                      <div className="validation-complete">
                        <div className="status-message success-with-emoji">
                          <span className="emoji">😊</span>
                          File Uploaded Successfully
                        </div>
                        <div className="validation-result">
                          Validation Successful
                        </div>
                        <button className="btn-ok" onClick={() => setCurrentStep(3)}>
                          Ok
                        </button>
                      </div>
                    )}

                    {/* Show Try Again button if validation failed */}
                    {isValidationFailed && (
                      <div className="try-again-section">
                        <button
                          className="btn-try-again"
                          onClick={onTryAgain}
                        >
                          Try Again
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Step 3: Mapping */}
          {currentStep === 3 && (
            <div className="step-content mapping-step">
              <div className="mapping-layout">
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  {/* File Info Section */}
                  <div className="file-info-section">
                    <div>
                      <img className='csviconclass' src={csvicon} alt="" />
                    </div>
                    <div>
                      <div className="file-name-large">{uploadedFile?.name || 'samplefile.csv'}</div>
                      <span className="file-size-large">{uploadedFile?.size}</span>
                    </div>

                  </div>

                  <div>
                    <div className="file-meta-info">
                      <span className="file-entities">{getFileEntitiesCount()} Entries Found</span>
                    </div>
                  </div>
                </div>

                {/* Status Message */}
                {showAlreadyMapped && (
                  <div className="status-info">
                    <div className="info-message">
                      <span className="info-icon">ℹ️</span>
                      Some entries are already mapped. Remove them to proceed with valid entries.
                    </div>
                    <button
                      className="btn-remove-all"
                      onClick={onRemoveAllAlreadyMapped}
                      disabled={!validationResults?.unmappedValidCount && validationResults?.alreadyMappedCount === 0}
                    >
                      Remove All Already Mapped
                    </button>
                  </div>
                )}

                {/* Two Column Layout */}
                <div className="mapping-columns-container">
                  {/* Left Column - UIDs */}
                  <div className="mapping-column-wrapper">
                    <div className="entries-column scrollable-column">
                      {mappingData.map((entry, index) => (
                        <div key={entry.id} className="mapping-entry-container">
                          <div className="mapping-entry">
                            <span className="entry-prefix">{index + 1}</span>
                            <span className="entry-value">{entry.uid}</span>
                          </div>
                          {entry.isAlreadyMapped && (
                            <button
                              className="remove-entry-btn"
                              onClick={() => onRemoveEntry(entry.id)}
                              title="Remove this entry"
                            >
                              ×
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Right Column - VMIDs */}
                  <div className="mapping-column-wrapper">
                    <div className="entries-column scrollable-column">
                      {mappingData.map((entry, index) => (
                        <div key={entry.id} className="mapping-entry-container">
                          <div className="mapping-entry">
                            <span className="entry-prefix">{index + 1}</span>
                            <span className="entry-value">VMID: {entry.vmId}</span>
                          </div>
                          {entry.isAlreadyMapped && (
                            <div className="already-mapped-badge">
                              Already Mapped
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Map Button - Only show when unmapped data is visible */}
                {!showAlreadyMapped && mappingData.length > 0 && (
                  <div className="map-action-section">
                    <button
                      className="btn-map-large"
                      onClick={onMap}
                      disabled={isMapping}
                    >
                      {isMapping ? 'Mapping...' : `Map ${mappingData.length} Entries`}
                    </button>
                  </div>
                )}

                {/* Show Try Again button when no entries available for mapping */}
                {hasNoUnmappedEntries && (
                  <div className="no-entries-section">
                    <div className="no-entries-message">
                      No valid entries available for mapping.
                    </div>
                    <button
                      className="btn-try-again"
                      onClick={onTryAgain}
                    >
                      Try Again
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Validation Success Dialog */}
        {showValidationDialog && (
          <div className="bulk-dialog-overlay">
            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", width: "400px" }}>
              <div className="bulk-dialog-container">
                <div className="bulk-dialog-header">
                  <img src={validationsuccess} alt="" />
                  <h3>Validation Successful</h3>
                </div>
                <div className="bulk-dialog-actions">
                  <button className="bulk-btn-dialog-ok" onClick={onValidationDialogOk}>
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Missing Records Dialog */}
        {showMissingRecordsDialog && (
          <div className="bulk-dialog-overlay">
            <div className="bulk-dialog-container missing-records-dialog">
              <div className="bulk-dialog-header">
                <img src={validationfailed} alt="Validation Failed" className="missing-dialog-icon" />
                <h3>Validation Failed</h3>
              </div>

              <div className="missing-records-content">
               

                {validationResults?.missingRecords && validationResults.missingRecords.length > 0 ? (
                  <>
                    <div className="missing-records-list">
                      {validationResults.missingRecords.map((record, index) => (
                        <div key={index} className="missing-record-item">
                          Invalid data
                          <div className="missing-record-pair">
                            {record.uids && record.uids.length > 0 && (
                              <div className="missing-record-field">
                                <strong>UIDs ({record.uids.length})</strong>
                                <div className="missing-record-values">
                                  {record.uids.join(', ')}
                                </div>
                              </div>
                            )}

                            {record.vmIds && record.vmIds.length > 0 && (
                              <div className="missing-record-field">
                                <strong>VMIDs ({record.vmIds.length})</strong>
                                <div className="missing-record-values">
                                  {record.vmIds.join(', ')}
                                </div>
                              </div>
                            )}
                          </div>

                       
                        </div>
                      ))}
                    </div>

                   
                  </>
                ) : (
                  <div className="missing-records-empty">
                    <p>No missing records to display.</p>
                  </div>
                )}
              </div>

              <div className="missing-records-actions">
                <button
                  className="bulk-btn-dialog-try-again"
                  onClick={onTryAgain}
                >
                  Try Again
                </button>


              </div>
            </div>
          </div>
        )}

        {/* Mapping Success Dialog */}
        {showMappingSuccessDialog && (
          <div className="bulk-dialog-overlay">
            <div className="bulk-dialog-container">
              <div className="bulk-dialog-header success">
                <h3>Mapping Successful</h3>
              </div>
              <div className="bulk-dialog-content">
                <div className="bulk-success-message">
                  <p>Successfully processed {mappingData.length} UID-VM mappings!</p>
                  <p>All entries have been mapped successfully.</p>
                </div>
              </div>
              <div className="bulk-dialog-actions">
                <button className="bulk-btn-dialog-ok" onClick={onMappingSuccessDialogOk}>
                  Ok
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkUpload;